import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  DashboardCompleto,
  DashboardSummary,
  EquipoNoDevuelto,
  MaterialCritico,
} from './dashboard.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/dashboard`;

  getSummary(): Observable<DashboardSummary> {
    return this.http.get<DashboardSummary>(this.base);
  }

  getMaterialesCriticos(limit = 10): Observable<MaterialCritico[]> {
    return this.http.get<MaterialCritico[]>(
      `${this.base}/materiales-criticos`,
      { params: { limit: limit.toString() } }
    );
  }

  getEquiposNoDevueltos(limit = 10): Observable<EquipoNoDevuelto[]> {
    return this.http.get<EquipoNoDevuelto[]>(
      `${this.base}/equipos-no-devueltos`,
      { params: { limit: limit.toString() } }
    );
  }

  getCompleto(limit = 10): Observable<DashboardCompleto> {
    return this.http.get<DashboardCompleto>(`${this.base}/completo`, {
      params: { limit: limit.toString() },
    });
  }
}
